import ModalPortal from "../ModalPortal";

const CsvPreviewModal = ({ open, onClose, headers, rows }) => {
  if (!open) return null;

  return (
    <ModalPortal>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="relative w-full max-w-5xl max-h-[85vh] m-8 bg-white rounded-2xl shadow-xl flex flex-col overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0">
            <h2 className="text-base font-semibold text-gray-800">
              Recipients Preview
            </h2>
            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition text-gray-400 hover:text-gray-600"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                  d="M1 1L13 13M1 13L13 1"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>

          {/* Table */}
          <div className="flex-1 overflow-auto p-4">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="bg-[#EEF0FB]">
                  {headers.map((header, i) => (
                    <th
                      key={i}
                      className={`px-4 py-3 text-left text-gray-600 font-medium whitespace-nowrap ${
                        i === 0 ? "rounded-l-xl" : ""
                      } ${i === headers.length - 1 ? "rounded-r-xl" : ""}`}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr
                    key={i}
                    className="border-b border-gray-50 hover:bg-gray-50"
                  >
                    {headers.map((header, j) => (
                      <td
                        key={j}
                        className="px-4 py-2.5 text-gray-600 whitespace-nowrap"
                      >
                        {row[header] || ""}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

            {rows.length === 0 && (
              <p className="text-center text-gray-400 py-10 text-sm">
                No data to preview
              </p>
            )}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between px-6 py-3 border-t border-gray-100 flex-shrink-0">
            <span className="text-sm text-gray-500">
              {rows.length} record{rows.length !== 1 ? "s" : ""}
            </span>
            <button
              onClick={onClose}
              className="px-5 py-2 text-sm font-medium rounded-full border border-gray-200 hover:bg-gray-50 transition"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default CsvPreviewModal;
